/* eslint-disable react/no-danger */

function GoogleAnalytics() {
  return <></>;
}

export default GoogleAnalytics;
